export const widgetConfig = {
  minPrice: 55, // in CAD
};
